import { render, staticRenderFns } from "./articleclaim.vue?vue&type=template&id=0112d1ac&scoped=true&"
import script from "./articleclaim.vue?vue&type=script&lang=js&"
export * from "./articleclaim.vue?vue&type=script&lang=js&"
import style0 from "./articleclaim.vue?vue&type=style&index=0&id=0112d1ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0112d1ac",
  null
  
)

export default component.exports